module.exports = __webpack_public_path__ + "assets/img/kunming.2c7916e2.png";